import { create } from 'zustand';

// Маппинг gameType к subheader в меню
export const GAME_TYPE_TO_MENU = {
    NEIGHBOR: 'Насоли соседу',
    FAIR: 'Ярмарка',
    KILLER: 'Киллер',
    DOZOR: 'Дозор',
    LEGEND: 'Легенды',
    DEMOCRACY: 'Демократия',
    BET: 'Ставки',
    TEAM_TASK: 'Командные задания'
};

const useSmenaGamesStore = create((set, get) => ({
    // Map<gameType, boolean> - активные игры
    activeGames: {},
    isLoaded: false,

    // Установить все игры из API ответа
    setGames: (games) => {
        const activeGames = {};
        games.forEach(game => {
            activeGames[game.gameType] = game.active;
        });
        set({ activeGames, isLoaded: true });
    },

    // Установить статус одной игры
    setGameActive: (gameType, isActive) => {
        set(state => ({
            activeGames: {
                ...state.activeGames,
                [gameType]: isActive
            }
        }));
    },

    // Проверить активна ли игра
    isGameActive: (gameType) => {
        return get().activeGames[gameType] || false;
    },

    // Проверить активно ли меню по subheader
    isMenuActive: (subheader) => {
        const gameType = Object.entries(GAME_TYPE_TO_MENU)
            .find(([_, menuName]) => menuName === subheader)?.[0];

        // Если это не игровое меню - всегда показываем
        if (!gameType) return true;

        // Если данные ещё не загружены - скрываем игровые меню
        if (!get().isLoaded) return false;

        return get().activeGames[gameType] || false;
    },

    // Сбросить при смене смены
    reset: () => set({ activeGames: {}, isLoaded: false })
}));

export default useSmenaGamesStore;
